import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { getOneClickStandardLot } from '@ordersnproducts/modules/one-click-order/selectors/one-click-standard-lot.selector';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { OneClickPreviewField } from '@ordersnproducts/modules/one-click-order/util/constants/preview-fields';
import { UnitCode } from '@ordersnproducts/modules/one-click-order/util/enums/one-click-unit.enum';

@Injectable()
export class OneClickStdLotLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOneClickStandardLot),
      filter((standardLot) => !!(standardLot && standardLot.transportation)),
      map(({ transportation }) => {
        if (transportation.transportationList.length === 1) {
          formGroup.get(OneClickPreviewField.StandardLot).setValue(transportation.transportationList[0].capacity);
        }

        return transportation.transportationList.map((standardLot) => {
          return {
            id: standardLot.capacity,
            name: `${standardLot.capacity} ${UnitCode.Ton}`,
          };
        });
      }),
    );
  }
}
